import React, { useContext } from "react";
import { IconButton }        from "@mui/material";
import { useTheme }          from "@mui/material/styles";
import ThemeContext           from "../../../context/theme/ThemeContext";

const SunIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="5"/>
    <line x1="12" y1="2"  x2="12" y2="4"/>
    <line x1="12" y1="20" x2="12" y2="22"/>
    <line x1="2"  y1="12" x2="4"  y2="12"/>
    <line x1="20" y1="12" x2="22" y2="12"/>
    <line x1="4.22"  y1="4.22"  x2="5.64"  y2="5.64"/>
    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
    <line x1="4.22"  y1="19.78" x2="5.64"  y2="18.36"/>
    <line x1="18.36" y1="5.64"  x2="19.78" y2="4.22"/>
  </svg>
);

const MoonIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
  </svg>
);

// onBar — optional color map passed when rendered on the teal AppBar
// Without onBar it falls back to the normal theme token colors (e.g. login page)
const ThemeToggleButton = ({ onBar }) => {
  const theme              = useTheme();
  const t                  = theme.custom;
  const { mode, toggleMode } = useContext(ThemeContext);

  const color       = onBar ? "rgba(255,255,255,0.65)" : t.text3;
  const hoverColor  = onBar ? "rgba(255,255,255,0.90)" : t.text2;
  const borderColor = onBar ? "rgba(255,255,255,0.18)" : t.border2;
  const bgColor     = onBar ? "rgba(255,255,255,0.08)" : t.surface3;
  const hoverBg     = onBar ? "rgba(255,255,255,0.14)" : t.surface2;

  return (
    <IconButton
      onClick={toggleMode}
      size="small"
      sx={{
        width:        "32px",
        height:       "32px",
        borderRadius: "4px",
        background:   bgColor,
        border:       `1px solid ${borderColor}`,
        color,
        transition:   "all 0.18s ease",
        "&:hover": {
          background:  hoverBg,
          color:       hoverColor,
          borderColor: onBar ? "rgba(255,255,255,0.28)" : t.border3,
        },
      }}
    >
      {mode === "dark" ? <SunIcon /> : <MoonIcon />}
    </IconButton>
  );
};

export default ThemeToggleButton;